import { api } from '@/lib/api'
import type {
  Workflow,
  WorkflowParseResponse,
  WorkflowPayload,
  WorkflowRunsResponse,
  WorkflowsResponse,
} from './types'

export const workflowsApi = {
  list: () => api.get<WorkflowsResponse>('/api/tenant/workflows'),
  create: (body: WorkflowPayload) =>
    api.post<{ workflow: Workflow }>('/api/tenant/workflows', body),
  update: (id: string, body: WorkflowPayload) =>
    api.put<{ workflow: Workflow }>(`/api/tenant/workflows/${id}`, body),
  run: (id: string) => api.post<{ message?: string }>(`/api/tenant/workflows/${id}/run`),
  pause: (id: string) => api.post<{ message?: string }>(`/api/tenant/workflows/${id}/pause`),
  resume: (id: string) => api.post<{ message?: string }>(`/api/tenant/workflows/${id}/resume`),
  archive: (id: string) => api.post<{ message?: string }>(`/api/tenant/workflows/${id}/archive`),
  remove: (id: string) => api.del<{ message?: string }>(`/api/tenant/workflows/${id}`),
  runs: (id: string, limit = 50) =>
    api.get<WorkflowRunsResponse>(`/api/tenant/workflows/${id}/runs`, { query: { limit } }),
  allRuns: (limit = 100) =>
    api.get<WorkflowRunsResponse>('/api/tenant/workflows/runs', { query: { limit } }),
  parse: (prompt: string) =>
    api.post<WorkflowParseResponse>('/api/tenant/workflows/parse', { prompt }),
}
